module.exports = __webpack_public_path__ + "static/media/flowers.4d88e536.jpg";